<template>
  <v-card class="my-4 badges">
    <v-toolbar color="primary" flat dark>
      <v-toolbar-title>Badges</v-toolbar-title>
    </v-toolbar>
    <v-row no-gutters justify="center">
      <v-col
        v-show="myBadges.length"
        cols="12"
        md="4"
        class="grey lighten-4 align-center layout"
      >
        <v-carousel hide-delimiters height="400px" class="carousel">
          <v-carousel-item
            v-for="(badge, index) in myBadges"
            :key="`badges_collected_${index}`"
          >
            <v-row class="badge-highlight" justify-center column>
              <v-card-text>
                <img :src="badge.image_url" />
                <h3>{{ badge.name }}</h3>
                <p v-if="hasBadge(badge)">
                  {{ badge.badge_received_description }}
                </p>
                <p v-else>{{ badge.description }}</p>
                <span>
                  Unlocked
                  {{ badge.badge_received_at | moment('MMM Do, YYYY') }}
                </span>
              </v-card-text>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="12" md="8">
        <v-card-text>
          <p style="text-align: center;">
            {{ myBadges.length + ' of ' + badges.length }} badges collected.
          </p>
          <v-row justify="center" align="center">
            <v-col
              v-for="(badge, index) in badges"
              :key="`badges_${index}`"
              md="2"
              sm="4"
              cols="6"
            >
              <v-menu
                transition="slide-x-transition"
                open-on-hover
                content-class="badgeOverlay"
                max-width="200"
                nudge-left="65"
              >
                <template v-slot:activator="{ on }">
                  <section
                    v-on="on"
                    :class="['badgeImage', hasBadge(badge) ? '' : 'greyscale']"
                  >
                    <img :src="badge.image_url" />
                  </section>
                </template>
                <v-card>
                  <v-card-text>
                    <h3>{{ badge.name }}</h3>
                    <p v-if="hasBadge(badge)">
                      {{ badge.badge_received_description }}
                    </p>
                    <p v-else>{{ badge.description }}</p>
                    <span v-if="hasBadge(badge)">
                      Unlocked
                      {{
                        hasBadge(badge).badge_received_at
                          | moment('MMM Do, YYYY')
                      }}
                    </span>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Badge from '@/modules/badge/models/Badge'

export default {
  name: 'Badges',
  data() {
    return {
      myBadges: []
    }
  },
  computed: {
    badges() {
      return Badge.all()
    }
  },
  async mounted() {
    await Badge.dispatch('getBadges')
    this.myBadges = await Badge.dispatch(
      'getStudentBadges',
      this.$route.meta.type
    )
  },
  methods: {
    hasBadge(badge) {
      return this.myBadges.find(b => b.id === badge.id)
    }
  }
}
</script>

<style lang="scss">
.badges {
  .badge-highlight {
    text-align: center;
    height: 400px;

    img {
      width: 50%;
      min-width: 130px;
    }

    h3 {
      color: var(--v-primary-base);
      text-transform: uppercase;
      font-size: 20px;
      margin-top: 10px;
    }

    span {
      color: var(--v-primary-base);
    }
  }

  .carousel {
    box-shadow: none;
  }

  .badgeImage {
    img {
      cursor: pointer;
      width: 100%;
    }

    &.greyscale {
      img {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
        opacity: 0.8;
      }
    }
  }

  .v-carousel__prev,
  .v-carousel__next {
    i {
      color: var(--v-primary-base) !important;
    }
  }
}
.badgeOverlay {
  text-align: center;
  h3 {
    color: var(--v-primary-base);
    text-transform: uppercase;
    font-size: 16px;
    margin-top: 10px;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 13px;
  }

  span {
    margin-top: 10px;
    color: var(--v-primary-base);
    display: block;
    font-size: 11px;
  }
}
</style>
